<template>
  <div class="list-table">
    <div class="search">
      <el-select v-model="params.status" placeholder="状态筛选" @change="getApprovalList" clearable @clear="getApprovalList">
        <el-option label="未审批" value="1">
        </el-option>
        <el-option label="通过" value="2">
        </el-option>
        <el-option label="不通过" value="3">
        </el-option>
      </el-select>
    </div>

    <div class="table-box">
      <el-table :data="approvalList" style="width: 100%" :header-cell-style="{color:'#B4B4B4',height:'36px',border:'none',padding:0, background:'rgba(0,77,160,0.05)'}" :row-style="{height:'48px',padding:'0',background:'rgba(0,77,160,0.05)', borderRadius:'5px'} " :cell-style=" {fontSize:'14px',padding:0,border:'none',color:'#5C5C5C'}">
        <el-table-column label="服务名称" prop="serviceName" />
        <el-table-column label="调用方" prop="callerName" />
        <el-table-column label="状态">
          <template slot-scope="{row}">
            <span v-if="row.status=='1'">未审批</span>
            <span v-if="row.status=='2'">通过</span>
            <span v-if="row.status=='3'">未通过</span>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" prop="createTime" />
        <el-table-column label="操作" width="130">
          <template slot-scope="{row}">
            <el-button type="text" v-if="row.status=='1'" @click="handlePass(row,'2')">通过</el-button>
            <el-button type="text" v-if="row.status=='1'" @click="handlePass(row,'3')">不通过</el-button>
            <el-button v-if="row.status=='2'||row.status=='3'" type="text" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-button type="primary" :disabled="params.page_num==1" @click="handleUpPage">上一页</el-button>
      <el-button type="primary" @click="handleNextPage" :disabled="approvalList.length<10">下一页</el-button>
    </div>
  </div>
</template>

<script>
import { getApprovalList, deleteApproval, handleApproval } from '@/api/approval'
export default {
  data() {
    return {
      params: {
        page_num: 1,
        page_size: 10,
        status: ''
      },
      approvalList: [],
    }
  },
  mounted() {
    this.getApprovalList()
  },
  methods: {
    async getApprovalList() {
      const res = await getApprovalList(this.params)
      this.approvalList = res.list
    },

    async handlePass(row, val) {
      await handleApproval({
        id: row.id,
        status: val
      })
      const msg = val == '2' ? '认证通过' : '认证不通过'
      this.$message.success(msg)
      this.getApprovalList()
    },

    async handleDelete(row) {
      const confirmResult = await this.$confirm(
        '此操作将永久删除该审批, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消删除')
      }
      await deleteApproval({
        id: row.id
      })

      this.$message.success('删除成功')
      this.getApprovalList()
    },

    handleUpPage() {
      this.params.page_num--
      this.getApprovalList()
    },
    handleNextPage() {
      this.params.page_num++
      this.getApprovalList()
    }
  }
}
</script>

